import { Component, OnInit, Input } from '@angular/core';
import { ProviderServiceService } from '../../../core/services/provider-service.service';
import { ProviderService } from '../../../core/models/provider-service.model';
import { Real } from '../../../core/models/real.model';
import { Observable, combineLatest, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-popular-dishes',
  templateUrl: './popular-dishes.component.html',
  styleUrls: ['./popular-dishes.component.scss'],
})
export class PopularDishesComponent implements OnInit {

  services$: Observable<any>;

  @Input() popularDishesCategory: ProviderService;

  constructor( public translateService: TranslateService ) { }

  ngOnInit() {
    console.log('sdgsd');
    console.log( this.popularDishesCategory );
  }

}
